import React, { ReactNode } from "react";
import { useTranslation } from "./translation-context";

type Props = {
  id: string;
  params?: Record<string, unknown>;
};

export const T = ({ id, params }: Props): ReactNode => {
  const { t } = useTranslation();
  return <>{t(id, params)}</>;
};
